export enum TicketTab {
    MY_TICKET = 1,
    MY_TEAM_TICKET = 2 ,
    BONUS_REISSUE = 3,
    FORM_TICKET = 4,
    FD_TICKET = 5
}



// WEBPACK FOOTER //
// ./src/app/customerservice/enums/ticket-tab.enum.ts